import { render } from "./ConfigurationNoteTemplates.vue?vue&type=template&id=cd902d2a&scoped=true"
import script from "./ConfigurationNoteTemplates.vue?vue&type=script&lang=js"
export * from "./ConfigurationNoteTemplates.vue?vue&type=script&lang=js"

import "./ConfigurationNoteTemplates.vue?vue&type=style&index=0&id=cd902d2a&scoped=true&lang=scss"

import exportComponent from "/home/kitrin/builds/isoevolve/20261004-205117/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd902d2a"]])

export default __exports__